<template>
  <div class="pagination-wrapper" v-if="total > limit">
    <div class="pagination-hits">{{startPoint}} - {{endPoint}} of {{total}}</div>
    <div class="pagination-container">
      <i v-if="currPage != 1" class="iconfont" @click="goPrev">&#xe615;</i>
      <div class="page-items">
        <a v-for="item in showPages" :key="item" :class="['page-item', item == currPage ? 'active' : '']" @click="change(item)">{{item}}</a>
      </div>
      <i v-if="currPage != totalPages" class="iconfont" @click="goNext">&#xe628;</i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      type: [Number, String],
      default: 0,
      validator(value) {
        return typeof value == "number" || (typeof value == "string" && !isNaN(value));
      }
    },
    limit: {
      type: [Number, String],
      default: 24,
      validator(value) {
        return typeof value == "number" || (typeof value == "string" && !isNaN(value));
      }
    },
    current: {
      type: [Number, String],
      default: 1,
      validator(value) {
        return typeof value == "number" || (typeof value == "string" && !isNaN(value));
      }
    }
  },
  data() {
    return {
      currPage: 1,
      totalPages: 0
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.total && this.limit) {
        this.totalPages = Math.ceil(this.total / this.limit);
      }
      if (this.current < 1) this.currPage = 1;
      if (this.current > this.totalPages) this.currPage = this.totalPages;
      this.currPage = this.current;
    },
    change(item) {
      this.currPage = item;
      this.$emit('change', { currPage: this.currPage });
    },
    goNext() {
      this.currPage += 1;
      this.$emit('change', { currPage: this.currPage });
    },
    goPrev() {
      this.currPage -= 1;
      this.$emit('change', { currPage: this.currPage });
    }
  },
  computed: {
    startPoint() {
      return (this.currPage - 1) * this.limit + 1;
    },
    endPoint() {
      return Math.min(this.currPage * this.limit, this.total);
    },
    showPages() {
      let ret = [this.currPage - 2, this.currPage - 1, this.currPage, this.currPage + 1, this.currPage + 2];
      ret = ret.filter(item => item >= 1 && item <= this.totalPages);
      if (ret.length != 5) {
        if (ret[2] != this.currPage) {
          let last = ret[ret.length - 1], count = 5 - ret.length;
          for (let i = 1; i <= count; i++) {
            if (last + i <= this.totalPages) ret.push(last + i);
          }
        } else {
          let fisrt = ret[0], count = 5 - ret.length;
          for (let i = 1; i <= count; i++) {
            if (fisrt - i >= 1) ret.unshift(fisrt - i);
          }
        }
      }
      return ret;
    }
  },
  watch: {
    limit() {
      this.init();
    },
    total() {
      this.init();
    }
  }
};
</script>

<style lang="scss" scoped>
  .pagination-wrapper {
    position: relative;
    text-align: center;
    .pagination-hits {
      margin-bottom: 10px;
      font-weight: 400;
      font-size: calc(.875rem * 1.6);
    }
    .pagination-container {
      display: flex;
      justify-content: center;
      align-items: center;
      .iconfont {
        width: 25px;
        height: 25px;
        line-height: 25px;
        border-radius: 50%;
        cursor: pointer;
        &:hover {
          background-color: hsla(120,1%,71%,.5);
        }
      }
      .page-items {
        display: flex;
        a {
          display: inline-block;
          width: 25px;
          height: 25px;
          margin: 0 8px;
          line-height: 25px;
          border-radius: 50%;
          font-weight: 400;
          font-size: calc(.875rem * 1.6);
          cursor: pointer;
          &.active {
            color: #000;
            background-color: #b4b5b4;
          }
          &:hover {
            background-color: hsla(120,1%,71%,.5);
            font-weight: 400;
            text-decoration: underline;
          }
        }
      }
    }
  }
</style>
